export class Table {
  static isOnPage() {
    return $('.js-table').length !== 0;
  }

  constructor() {
    this.init();
  }

  init() {
    $.each($('.js-table'), (index, table) => {
      const $table = $(table);
      $.each($table.find('th'), (rowIndex, heading) => {
        $table.find(`td:nth-child(${rowIndex + 1})`)
          .attr('data-label', heading.innerText);
      });
    });
  }
}